import * as React from 'react';
import MenuList from '@material-ui/core/MenuList';
import { MenuItem } from '@material-ui/core';
import './ProfileMenu.css';
import SocialButton from '../../Login/SocialButton/SocialButton';
import { useHistory } from 'react-router-dom';
import { API_URL } from '../../../../utils';
import SettingIcon from '@material-ui/icons/SettingsOutlined';
import DraftIcon from '@material-ui/icons/DraftsOutlined';
import WebIcon from '@material-ui/icons/WebOutlined';
import ExitIcon from '@material-ui/icons/ExitToAppOutlined';

const ProfileMenu: React.FC = props => {
	const history = useHistory();

	const toSettings = () => {
		history.push('/settings');
	}

	const logout = () => {
		window.location.href = `${API_URL}/logout`;
	};

	return <div className="profile-mobile-menu__wrapper">
		<MenuList
			classes={{
				root: 'profile-mobile-menu'
			}}
		>
			<MenuItem onClick={toSettings}>
				<SettingIcon/>

				Настройки профиля
			</MenuItem>

			<MenuItem onClick={() => {
				window.location.href = "https://readed.me/contact/";
			}}>
				<DraftIcon/>

				Написать нам
			</MenuItem>

			<MenuItem onClick={logout}>
				<ExitIcon/>

				Выйти из аккаунта
			</MenuItem>
		</MenuList>

		{/*<SocialButton onClick={() => {
			window.location.href = "https://vk.com/readed_me";
		}} type="vk" text="Сообщество ВКонтакте" />*/}
	</div>;
};

export default ProfileMenu;
